<template>
  <div id="position_code_list">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>

    <div id="page-content-wrapper" class="admin-content-area"
         :style="listOnly ? 'padding-top: 0 !important;padding-bottom: 0 !important' : ''">
      <template v-if="cantAccessPage === true">
        <div class="page-name" v-if="!listOnly">
          <div class="page-title"> Position Code</div>
          <div class="btn-groups text-right">
            <router-link v-if="addPositionCode" class="btn btn-primary" v-bind:to="{name: 'PositionCodeCreate'}"><i
                class="fp-add"> </i> Add
            </router-link>
          </div>
        </div>
        <div class="container-fluid" :class="listOnly ? 'no-height-limit' : ''">
          <div class="admin-page-content position_code_list">
            <data-table-filter-config :moduleName="'PositionCodeList'" ref="filterPositionCode"
                                      @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                 :moduleName="'PositionCodeList'" :position="'top'">
              </custom-pagination>

              <vue-good-table :class="listOnly ? 'table-list-only-height' : ''" ref="listPositionCodeTable"
                              mode="remote"
                              title="Position Code" @on-page-change="onPageChange"
                              @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                              @on-sort-change="onSortChange" :totalRows="totalRecords" :columns="userColumns"
                              :rows="rows"
                              :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
                              :select-options="{
                                    enabled: deletePositionCode && !listOnly,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                              :search-options="{
                                enabled: false,
                                }"
              >

                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field === 'action'">
                      <router-link v-if="updatePositionCode" title="Edit Position Code" class="fp-edit mr-3"
                                   v-bind:to="{ name: 'PositionCodeEdit', params: { id: props.row.id } }">
                      </router-link>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>
                <div slot="selected-row-actions">
                  <button v-if="deletePositionCode" id="deletePositionCodeBtn" v-on:click.prevent="positionCodeDelete"
                          class="btn btn-danger">Delete
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination v-if="!listOnly" :page-changed="onPageChange" :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer v-if="!listOnly"></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "PositionCodeList",
  mixins: [commonMixins, dataTableMixins],
  props: {
    listOnly: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
        hidden: true
      },
      {
        label: 'id',
        field: 'id',
        fpFieldType: "text",
        filterable: false,
        hidden: true,
      },
      {
        label: 'Code',
        field: 'code',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'System',
        field: 'system',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "System", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Sub System',
        field: 'sub_system',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Sub System", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: [],
    deletePositionCode: false,
    updatePositionCode: false,
    viewPositionCode: false,
    addPositionCode: false,
    loading: false
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name === 'ev_list_position_code') {
            this.cantAccessPage = true;
          }
          if (permissions[i].name === 'ev_view_position_code') {
            this.viewPositionCode = true;
          }
          if (permissions[i].name === 'ev_create_position_code') {
            this.addPositionCode = true;
            this.updatePositionCode = true;
          }
          if (permissions[i].name === 'ev_delete_position_code') {
            this.deletePositionCode = true;
          }
        }
        if (!this.listOnly && this.addPositionCode) {
          this.$nextTick(() => {
            this.columns[0].hidden = false;
          });
        }
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    if (!self.listOnly) {
      document.title = "Position Code | " + process.env.COPYRIGHT_NAME;
    }
  },
  methods: {
    cancelAll: function () {
      this.$refs.listPositionCodeTable.unselectAllInternal();
    },

    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        // messageData: self.message,
        sort: self.serverParams.sort,
        // exportFiltered: self.exportFilteredFlag
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/position-code/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (jqXHR.status === 0) {
            self.errorMsg = "Remote server cannot be reached";
          } else {
            //redirect to login page if user not authenticated
            if (jqXHR.status === 401) {
              //clear previous data
              localStorage.removeItem("user_obj");
              localStorage.removeItem("tkn");

              self.$router.push("/");
            }
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    },

    positionCodeDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this Position Code?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          var data = this.$refs['listPositionCodeTable'].selectedRows;
          var use = [];
          for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listPositionCodeTable'].selectedRows[i].id)
          }
          self.loading = true;
          $("#deletePositionCodeBtn").val("Deleting ...");
          $.ajax({
            url: process.env.ROOT_API + "/position-code/delete",
            type: "POST",
            data: 'id=' + use,
            headers: this.ajxHeaders,
            dataType: 'json',
            success: function (data) {
              self.loading = false;
              setTimeout(function () {
                $(".alert-success").removeClass("show");
                $(".alert-success").addClass("hide");
              }, 10000);
              setTimeout(function () {
                $("#deletePositionCodeBtn").val("Delete");
              }, 10000);

              var currentlyMapped = data.content.currentlyMappedArr;
              self.notDeletedSwal(currentlyMapped);

              self.loadList();
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'position-code-delete')
            }
          });

        } else {
          console.log("no");
        }
      });
    },
    notDeletedSwal(currentlyMapped) {
      if (currentlyMapped.length > 0) {
        currentlyMapped = currentlyMapped.toString();
        this.$swal({
          title: 'The following position code/s could not be deleted, as they are currently in use!',
          text: currentlyMapped,
          type: 'warning',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: 'Close',
        });
      }
    }
  }
};
</script>
<style scoped>
.table-list-only-height {
  height: 50vh;
  overflow: auto;
}

.no-height-limit {
  min-height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PositionCodeList.vue